export const chatCircle = [
  '0 0 28 28',
  `<path
d="M3.72961 15.3896C2.74891 13.7373 2.40516 11.7838 2.76294 9.89606C3.12071 8.00827 4.15539 6.31605 5.67264 5.13721C7.18989 3.95836 9.08533 3.37401 11.003 3.49389C12.9206 3.61377 14.7285 4.42964 16.0872 5.78826C17.4458 7.14689 18.2617 8.9548 18.3815 10.8724C18.5014 12.7901 17.9171 14.6855 16.7382 16.2028C15.5594 17.72 13.8671 18.7547 11.9794 19.1125C10.0916 19.4703 8.13812 19.1265 6.48586 18.1458L3.76242 18.9224C3.65021 18.9539 3.53162 18.955 3.41885 18.9255C3.30608 18.8961 3.20319 18.8371 3.12077 18.7547C3.03834 18.6722 2.97936 18.5693 2.94989 18.4566C2.92041 18.3438 2.9215 18.2252 2.95305 18.113L3.72961 15.3896Z"
stroke="#495057"
stroke-width="1.4"
stroke-linecap="round"
stroke-linejoin="round"
/>
<path
d="M10.0723 19.2408C10.4578 20.3399 11.0826 21.3396 11.9015 22.1677C12.7205 22.9959 13.7132 23.6317 14.8079 24.0294C15.9026 24.4271 17.072 24.5767 18.2315 24.4673C19.3911 24.358 20.5118 23.9924 21.5129 23.3971L24.2363 24.1736C24.3485 24.2052 24.4671 24.2063 24.5799 24.1768C24.6927 24.1473 24.7956 24.0883 24.878 24.0059C24.9604 23.9235 25.0194 23.8206 25.0489 23.7078C25.0783 23.5951 25.0773 23.4765 25.0457 23.3643L24.2691 20.6408C24.9624 19.4771 25.3434 18.154 25.375 16.7998C25.4067 15.4455 25.088 14.1061 24.4499 12.9112C23.8117 11.7164 22.8758 10.7066 21.7327 9.97977C20.5896 9.25294 19.2781 8.83371 17.9254 8.7627"
stroke="#495057"
stroke-width="1.4"
stroke-linecap="round"
stroke-linejoin="round"
/>`,
]
